import { combineReducers } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import message from 'antd/lib/message';
import api from '../api';
import {
  createApiActionCreators,
  createActionType,
  createReducer,
  SUCCESS,
  REQUEST,
} from '../../../common/utils/reduxHelpers';
import { t } from '../../../app/i18n';

/**
 * ACTION TYPES
 */
export const WITHDRAW_FUNDS = 'payments/WITHDRAW_FUNDS';
export const FETCH_PAYMENTS = 'payments/FETCH_PAYMENTS';

/**
 * ACTIONS
 */
export const withdrawFundsActions = createApiActionCreators(WITHDRAW_FUNDS);
export const fetchPaymentsByAccountIdActions = createApiActionCreators(FETCH_PAYMENTS);

const initialState = {
  payments: [],
};
const payments = createReducer(initialState.payments, {
  [FETCH_PAYMENTS]: {
    [SUCCESS]: (state, payload) => payload,
  },
});

export default combineReducers({
  payments,
});

export const selectPaymentsByAccountId = state => state.payments.payments;
/**
 * SAGAS
 */
function* withdrawFunds({ payload }) {
  const resp = yield call(api.withdrawFunds, payload.accountId, payload.amount);

  if (resp.ok) {
    yield put(withdrawFundsActions.success(resp.data.account));
    message.success(t('Prevod bol úspešne zrealizovaný'));
    yield put(push('/dashboard'));
  } else {
    yield put(withdrawFundsActions.failure(resp.error));
  }
}

function* fetchPaymentsByAccountId({payload}) {
  const resp = yield call(api.fetchPayments, payload.accountId);
  if (resp.ok) {
    yield put(fetchPaymentsByAccountIdActions.success(resp.data));
  } else {
    yield put(fetchPaymentsByAccountIdActions.failure(resp.error));
  }
}

export function* paymentsSaga() {
  yield takeLatest(createActionType(WITHDRAW_FUNDS, REQUEST), withdrawFunds);
  yield takeLatest(createActionType(FETCH_PAYMENTS, REQUEST), fetchPaymentsByAccountId);
}



// WEBPACK FOOTER //
// ./src/features/payments/ducks/index.js